import MarHero from "@/components/landing/mar/MarHero";
import MarContent from "@/components/landing/mar/MarContent";
import MarInvestment, { MarTeam } from "@/components/landing/mar/MarInvestment";
import MarQuote from "@/components/landing/mar/MarQuote";
import Stats from "@/components/landing/Stats";
import AboutUs from "@/components/landing/AboutUs";
import Testimonials from "@/components/landing/Testimonials";

const Index = () => {
  return (
    <main className="casa-proposal">
      <MarHero />
      <MarContent />
      <div className="casa-institutional"><Stats /><AboutUs /><MarTeam /><Testimonials /></div>
      <MarQuote />
      <MarInvestment />
    </main>
  );
};

export default Index;
